export function taskAssignedToSelectedPersonPredicate(task, selectedPersonId) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = task === null || task === void 0 ? void 0 : task.node) === null || _a === void 0 ? void 0 : _a.assignedPersons) === null || _b === void 0 ? void 0 : _b.map(assignedPerson => assignedPerson === null || assignedPerson === void 0 ? void 0 : assignedPerson.id)) === null || _c === void 0 ? void 0 : _c.includes(selectedPersonId));
}
